import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  weight: number | undefined;
}

export function Weight({ weight }: Props) {
  const { i18n } = useTranslation();

  if (weight === undefined) {
    return false;
  }

  // This number cast might look a little uneccesary, but it's due to a runtime type issue where we
  // change the type of uint64 to a number, but in reality (runtime) it's actually a string.
  return Number(weight).toLocaleString(i18n.resolvedLanguage, {
    unitDisplay: 'short',
    unit: 'gram',
    style: 'unit',
  });
}
